import { api } from "../../lib";

export interface CollectionMethod {
  id: string;
  name: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCollectionMethodInput {
  name: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateCollectionMethodInput
  extends Partial<CreateCollectionMethodInput> {
  id: string;
}

export const collectionMethodsService = {
  getAll: async () => {
    return api.get<CollectionMethod[]>("/admin/collection-methods");
  },

  getById: async (id: string) => {
    return api.get<CollectionMethod>(`/admin/collection-methods/${id}`);
  },

  create: async (input: CreateCollectionMethodInput) => {
    return api.post<CollectionMethod>("/admin/collection-methods", {
      name: input.name,
      description: input.description,
      isActive: input.isActive ?? true,
    });
  },

  update: async (input: UpdateCollectionMethodInput) => {
    const { id, ...updates } = input;
    return api.put<CollectionMethod>(
      `/admin/collection-methods/${id}`,
      updates
    );
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<CollectionMethod>(`/admin/collection-methods/${id}`, {
      isActive,
    });
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/collection-methods/${id}`);
  },
};
